
import { useEffect } from "react";
import { useOutletContext } from "react-router-dom";


export default function About() {

    // functions from App component
    // to transit values of JWT and errors to App component
    const { setAlertClassName } = useOutletContext();
    const { setAlertMessage } = useOutletContext();

    // delete all the previous errors
    useEffect(() => {
        setAlertClassName("d-none"); // hide alert if it was
        setAlertMessage("");
    }, [setAlertClassName, setAlertMessage]);


    return (
        <div className="container">
            <div className="row">
                <div className="col">
                    <h1 className="mt-3 display-6">About</h1>
                    <h6 className="fw-lighter">Alfa 1.01</h6>
                    <hr />
                    <h3 className="fw-lighter">Current features:</h3>
                    <ul>
                        <li><h4 className="fw-lighter">Search information in sources headlines in the <strong>last 24 hours</strong></h4></li>
                        <li><h4 className="fw-lighter">10 <strong>FREE</strong> requests available every day</h4></li>
                        <li><h4 className="fw-lighter">Search up to 7 words in one request</h4></li>
                        <li><h4 className="fw-lighter">Store up to 10 reports</h4></li>
                        <li><h4 className="fw-lighter">Create scheduled tasks and receive reports at specified time</h4></li>
                    </ul>
                </div>
                <hr />
                <h4 className="fw-lighter">Contact us: info@virgilia.ru</h4>
            </div>
        </div>
    )
}